module.exports = __webpack_public_path__ + "static/wireframe-desk-5f0ca852cd4c70d0584941fb814ec1f1.png";